import { useState, useCallback, useEffect } from 'react'

import { Box, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import CollegeCrest from '@scoir/college-crest'
import useScid from 'common/use-scid'
import api from 'common/api'

import Loading from '../Loading'
import Metrics from './Metrics'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#0A6BB8',
    color: theme.palette.primary.contrastText,
    marginTop: theme.spacing(1),
  },
  boarder: {
    borderRadius: 4,
    padding: 1,
  },
}))

export type Insights = {
  total: number
  last30Days: number
}

const AudienceInsights = () => {
  const classes = useStyles()
  const scid = useScid()

  const [isLoading, setIsLoading] = useState(false)
  const [insights, setInsights] = useState<Insights>({ total: 0, last30Days: 0 })
  const getInsights = useCallback(() => {
    setIsLoading(true)
    api
      .get<Insights>(`/api/colleges/${scid}/metrics/type/interested-students`)
      .then((response) => {
        const insights: Insights = {
          total: response.total,
          last30Days: response.last30Days,
        }
        setInsights(insights)
      })
      .finally(() => setIsLoading(false))
  }, [scid])
  useEffect(getInsights, [getInsights])

  return (
    <Paper
      className={classes.root}
      elevation={0}
    >
      <Box
        p={2}
        width="100%"
        display="inline-flex"
        alignItems="center"
      >
        <Paper
          className={classes.boarder}
          elevation={0}
        >
          <CollegeCrest scid={scid} />
        </Paper>
        <Box
          pl={2}
          width="100%"
        >
          <Loading
            isLoading={isLoading}
            loadingText="Loading data"
            loadingBubbles
          >
            <Metrics
              total={insights.total}
              last30Days={insights.last30Days}
            />
          </Loading>
        </Box>
      </Box>
    </Paper>
  )
}

export default AudienceInsights
